<template>
  <DetailTemplate
    :custom-class="'quotation-detail detail-page'"
    v-if="getPermission('proforma:view')"
  >
    <template v-slot:sidebar-detail>
      <v-card class="h-100" elevation="0">
        <div class="d-flex px-0 flex-wrap align-center">
          <!-- <Status :status="customerActivated"></Status> -->
          <template v-if="detail && detail.status">
            <span class="my-1">
              <CustomStatus
                :status="detail.status"
                endpoint="proforma/status"
              ></CustomStatus>
            </span>
            <span>
              <v-chip
                label
                class="text-capitalize ml-1 font-weight-500"
                text-color="white"
                :color="detail.tag_type == 'overseas' ? 'blue' : 'red'"
              >
                {{ detail.tag_type }}
              </v-chip>
            </span>
          </template>
        </div>

        <div class="mt-4 px-0">
          <table width="100%">
            <tr>
              <th
                colspan="2"
                class="grey lighten-4 font-size-16 color-custom-blue py-1"
              >
                Proforma Information
              </th>
            </tr>
            <tr>
              <td
                valign="middle"
                class="py-1 font-size-18 font-weight-600"
                width="130"
              >
                Proforma #
              </td>
              <td valign="middle" class="py-1 font-size-18 font-weight-500">
                <v-chip
                  label
                  color="chip-custom-blue"
                  outlined
                  class="text-white p-3"
                  small
                  >{{ detail.barcode }}
                </v-chip>
              </td>
            </tr>
            <tr>
              <td
                valign="middle"
                class="py-1 font-size-18 font-weight-600"
                width="130"
              >
                Order #
              </td>
              <td valign="middle" class="py-1 font-size-18 font-weight-500">
                <router-link
                  :to="{
                    name: 'admin.orders.detail',
                    params: { id: detail?.order_relation?.id },
                  }"
                >
                  <v-chip
                    label
                    color="red"
                    outlined
                    class="text-white p-3"
                    small
                    >{{ detail?.order_relation?.barcode }}
                  </v-chip>
                </router-link>
              </td>
            </tr>
            <tr>
              <td
                valign="middle"
                class="py-1 font-size-18 font-weight-600"
                width="130"
              >
                Proforma Type
              </td>
              <td valign="middle" class="py-1 font-size-18 font-weight-500">
                <v-chip
                  v-if="detail?.proforma_type"
                  small
                  class="text-white p-3 cursor-pointer mt-1 text-capitalize"
                  :color="detail?.proforma_type == 'initial' ? 'red' : 'green'"
                  label
                  outlined
                >
                  {{ detail?.proforma_type }}
                  <template v-if="detail?.proforma_type == 'initial'">
                    {{ Number(detail.initial_payment_in_percentage) }} %
                  </template>
                </v-chip>
              </td>
            </tr>
            <tr>
              <td
                valign="middle"
                class="py-1 font-size-18 font-weight-600"
                width="130"
              >
                Proforma PDF
              </td>
              <td valign="middle" class="py-1 font-size-18 font-weight-500">
                <v-icon color="red" v-on:click.stop.prevent="downloadFile()"
                  >mdi-file-pdf-box</v-icon
                >
              </td>
            </tr>
            <tr>
              <td valign="middle" class="py-1 font-size-18 font-weight-600">
                Transaction ID<!-- Customer Reference # -->
              </td>
              <td valign="middle" class="py-1 font-size-18 font-weight-500">
                <label class="m-0" v-if="detail.transaction_id">{{
                  detail.transaction_id
                }}</label>
                <em class="text-muted" v-else> no Transaction ID</em>
              </td>
            </tr>
            <tr>
              <td valign="middle" class="py-1 font-size-18 font-weight-600">
                Payment Mode
              </td>
              <td valign="middle" class="py-1 font-size-18 font-weight-500">
                <label class="m-0" v-if="detail.payment_mode">{{
                  detail.payment_mode
                }}</label>
                <em class="text-muted" v-else> no Payment Mode</em>
              </td>
            </tr>
            <tr v-if="detail.date">
              <td valign="middle" class="py-1 font-size-18 font-weight-600">
                Date
              </td>
              <td valign="middle" class="py-1 font-size-18 font-weight-500">
                <label class="m-0">
                  {{ formatDate(detail.date) }}
                </label>
              </td>
            </tr>
            <tr v-if="detail.added_at">
              <td valign="middle" class="py-1 font-size-18 font-weight-600">
                Created
              </td>
              <td valign="middle" class="py-1 font-size-18 font-weight-500">
                <label class="m-0">
                  {{ formatDate(detail.added_at) }}
                </label>
              </td>
            </tr>
            <tr v-if="detail?.payment_term">
              <td valign="top" class="py-1 font-size-18 font-weight-600">
                Term
              </td>
              <td valign="middle" class="py-1 font-size-18 font-weight-600">
                <label class="m-0">
                  <span class="">{{ detail?.payment_term }}</span>
                </label>
              </td>
            </tr>
            <tr v-if="detail?.sale_by_relation">
              <td valign="top" class="py-1 font-size-18 font-weight-600">
                Sales Representative
              </td>
              <td valign="middle" class="py-1 font-size-18 font-weight-600">
                <label class="m-0"
                  ><router-link
                    :to="{
                      name: 'admin.user.detail',
                      params: { id: detail.sale_by_relation.id },
                    }"
                    ><v-chip
                      v-if="
                        detail &&
                        detail.sale_by_relation &&
                        detail.sale_by_relation.display_name
                      "
                      small
                      class="mb-1 mr-1"
                    >
                      <v-avatar left small>
                        <img
                          v-if="
                            detail.sale_by_relation &&
                            detail.sale_by_relation.profile_logo &&
                            detail.sale_by_relation.profile_logo.file
                          "
                          :src="detail.sale_by_relation.profile_logo.file.url"
                        />
                        <img
                          v-else
                          src="https://ams-dev.businessthrust.com//media/misc/no_photo_found.png"
                        />
                      </v-avatar>
                      <span>{{ detail.sale_by_relation.display_name }}</span>
                    </v-chip></router-link
                  ></label
                >
              </td>
            </tr>
            <tr
              v-if="
                detail.order_relation?.grand_total &&
                detail.order_relation?.grand_total > 0
              "
            >
              <td valign="middle" class="py-1 font-size-18 font-weight-700">
                Order Con. Total
              </td>
              <td valign="middle" class="py-1 font-size-18 font-weight-500">
                <label class="m-0">
                  <span
                    class="font-weight-bold color-custom-blue font-size-21"
                    >{{ formatMoney(detail.order_relation?.grand_total) }}</span
                  >
                </label>
              </td>
            </tr>

            <template v-if="detail?.invoice_relation?.id > 0">
              <tr>
                <th
                  colspan="2"
                  class="grey lighten-4 font-size-16 color-custom-blue py-1"
                >
                  Invoice Information
                </th>
              </tr>

              <tr>
                <td valign="middle" class="py-1 font-size-18 font-weight-600">
                  Invocie Date
                </td>
                <td
                  valign="middle"
                  class="py-1 font-size-18 font-weight-500 d-flex"
                >
                  <label class="m-0" v-if="detail.invoice_relation.invoice_date"
                    ><b>{{
                      formatDate(detail.invoice_relation.invoice_date)
                    }}</b></label
                  >
                  <em class="text-muted" v-else> no Invocie Date</em>
                  <v-spacer> </v-spacer>
                  <v-icon
                    v-if="
                      detail?.invoice_relation?.payment_status != 'complate'
                    "
                    color="red"
                    class="mr-1"
                    v-on:click.stop.prevent="invoiceUpdateDialog()"
                    >mdi-pencil</v-icon
                  >
                  <v-icon
                    color="cyan"
                    v-on:click.stop.prevent="invoiceViewDialog()"
                    >mdi-eye</v-icon
                  >
                </td>
              </tr>
              <tr>
                <td valign="middle" class="py-1 font-size-18 font-weight-600">
                  Invoice Amount
                </td>
                <td valign="middle" class="py-1 font-size-18 font-weight-500">
                  <label
                    class="m-0"
                    v-if="detail.invoice_relation.invoice_amount"
                    ><b>{{
                      formatMoney(detail.invoice_relation.invoice_amount)
                    }}</b></label
                  >
                  <em class="text-muted" v-else> no Invocie amount</em>
                </td>
              </tr>
              <tr>
                <td valign="middle" class="py-1 font-size-18 font-weight-600">
                  Collected Amount
                </td>
                <td valign="middle" class="py-1 font-size-18 font-weight-500">
                  <label
                    class="m-0"
                    v-if="detail.invoice_relation.collected_amount"
                    ><b>{{
                      formatMoney(detail.invoice_relation.collected_amount)
                    }}</b></label
                  >
                  <em class="text-muted" v-else> no Collected Amount</em>
                </td>
              </tr>
              <tr>
                <td valign="middle" class="py-1 font-size-18 font-weight-600">
                  Payment Status
                </td>
                <td valign="middle" class="py-1 font-size-18 font-weight-500">
                  <label
                    class="m-0"
                    v-if="detail.invoice_relation.payment_status"
                  >
                    <template v-if="detail.invoice_relation.payment_status">
                      <v-chip
                        label
                        small
                        :color="
                          detail.invoice_relation.payment_status == 'complate'
                            ? 'green'
                            : 'red'
                        "
                        text-color=""
                        outlined
                      >
                        <template
                          v-if="
                            detail.invoice_relation.payment_status == 'complate'
                          "
                        >
                          Complete
                        </template>
                        <template v-else> Pending </template>
                      </v-chip>
                    </template></label
                  >
                  <em class="text-muted" v-else> no Payment Status</em>
                </td>
              </tr>
              <tr>
                <td colspan="2" class="py-1">Invoice Remark</td>
              </tr>
              <tr>
                <td
                  valign="middle"
                  class="py-1 font-size-18 font-weight-500"
                  colspan="2"
                >
                  <label class="m-0" v-if="detail.invoice_relation.remark">{{
                    detail.invoice_relation.remark
                  }}</label>
                  <em class="text-muted" v-else> no Invoice Remark</em>
                </td>
              </tr>
            </template>
          </table>
        </div>
      </v-card>
    </template>
    <template v-slot:header-title>
      <span
        v-if="pageLoaded"
        class="color-custom-blue font-weight-700 font-size-20 mr-2 text-capitalize"
        >{{ detail.title }}</span
      >
    </template>
    <template v-slot:header-action>
      <div class="d-flex align-center justify-end" v-if="pageLoaded">
        <v-btn
          v-if="detail?.status == 1"
          v-on:click="editProforma()"
          depressed
          color="cyan mx-1 white--text"
          class="custom-bold-button"
          ><v-icon small left>mdi-pencil</v-icon>Edit</v-btn
        >
        <v-menu
          v-if="false"
          transition="slide-y-transition"
          bottom
          content-class="custom-menu-list"
          offset-y
          left
          style="z-index: 99 !important"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              depressed
              :disabled="statusLoading"
              class="mx-1 custom-bold-button white--text"
              color="cyan"
              v-bind="attrs"
              v-on="on"
            >
              More... <v-icon right>mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-list>
            <template v-for="(more, index) in moreActions">
              <v-list-item
                link
                v-on:click="updateMoreAction(more.action)"
                :key="index"
                :disabled="statusLoading || more.disabled"
              >
                <v-list-item-icon class="margin-auto-zero mr-3 my-2">
                  <v-icon class="icon-default-blue">{{ more.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title class="font-weight-500 font-size-14">{{
                  more.title
                }}</v-list-item-title>
              </v-list-item>
            </template>
          </v-list>
        </v-menu>
        <v-btn
          depressed
          class="mx-1 custom-grey-border custom-bold-button"
          v-on:click="goBack()"
        >
          <v-icon small left>mdi-keyboard-backspace</v-icon>
          Back
        </v-btn>
      </div>
    </template>
    <template v-slot:body>
      <v-container fluid v-if="pageLoaded">
        <v-tabs
          active-class="custom-tab-active"
          v-model="orderTab"
          background-color="transparent"
          color="cyan"
          class="custom-tab-transparent tab-sticky"
        >
          <v-tab class="font-size-16 font-weight-600 px-8" href="#other">
            <span class="svg-icon svg-icon-lg mr-4 svg-v-list-icon">
              <!--begin::Svg Icon-->
              <inline-svg :src="$assetURL('media/custom-svg/quotation.svg')" />
              <!--end::Svg Icon-->
            </span>
            Overview
          </v-tab>
          <v-tab
            class="font-size-16 font-weight-600 px-8"
            href="#line-item-new"
          >
            <span class="svg-icon svg-icon-lg mr-4 svg-v-list-icon">
              <!--begin::Svg Icon-->
              <inline-svg :src="$assetURL('media/custom-svg/line-item.svg')" />
              <!--end::Svg Icon-->
            </span>
            Line Items
          </v-tab>
          <v-tab
            class="font-size-16 font-weight-600 px-8"
            href="#proforma"
            v-if="false"
          >
            <span class="svg-icon svg-icon-lg mr-4 svg-v-list-icon">
              <!--begin::Svg Icon-->
              <inline-svg :src="$assetURL('media/custom-svg/line-item.svg')" />
              <!--end::Svg Icon-->
            </span>
            Proforma
          </v-tab>
          <v-tab
            class="font-size-16 font-weight-600 px-8"
            href="#line-item"
            v-if="false"
          >
            <span class="svg-icon svg-icon-lg mr-4 svg-v-list-icon">
              <!--begin::Svg Icon-->
              <inline-svg :src="$assetURL('media/custom-svg/line-item.svg')" />
              <!--end::Svg Icon-->
            </span>
            Costing Line Items
          </v-tab>
          <v-tab
            class="font-size-16 font-weight-600 px-8"
            href="#attachments"
            v-if="false"
          >
            <span class="svg-icon svg-icon-lg mr-4 svg-v-list-icon">
              <!--begin::Svg Icon-->
              <inline-svg :src="$assetURL('media/custom-svg/attachment.svg')" />
              <!--end::Svg Icon-->
            </span>
            Attachments
          </v-tab>
          <v-tab class="font-size-16 font-weight-600 px-8" href="#history">
            <span class="svg-icon svg-icon-lg mr-4 svg-v-list-icon">
              <!--begin::Svg Icon-->
              <inline-svg :src="$assetURL('media/custom-svg/history.svg')" />
              <!--end::Svg Icon-->
            </span>
            History
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="orderTab">
          <v-tab-item value="other">
            <v-container fluid>
              <v-card flat class="custom-grey-border remove-border-radius mb-4">
                <v-card-title class="headline grey lighten-4 py-1">
                  <span
                    class="font-weight-700 custom-headline color-custom-blue font-size-16"
                    >Address Detail</span
                  >
                </v-card-title>
                <v-card-text class="p-6 font-size-16">
                  <span class="color-custom-blue font-weight-700 font-size-19">
                    <router-link
                      :to="
                        getDefaultRoute('company.detail', {
                          params: {
                            id: detail?.customer_relation?.id,
                          },
                        })
                      "
                      >{{ detail?.customer_relation.company_name }}
                    </router-link>
                  </span>
                  <v-layout class="my-4">
                    <v-flex md6 class="mr-2 custom-border-right" v-if="false">
                      <table width="100%">
                        <tr>
                          <td class="font-weight-600">
                            <span
                              class="font-weight-700 custom-headline color-custom-blue font-size-16"
                            >
                              Site Location</span
                            >
                          </td>
                        </tr>
                        <tr>
                          <td class="py-0 font-size-18 font-weight-500">
                            <template>
                              <div
                                class="custom-flex-d"
                                v-if="detail?.property_relation?.property_name"
                              >
                                <b>
                                  <v-icon
                                    style="
                                      font-size: 18px;
                                      margin-top: -3px !important;
                                    "
                                    color="#000"
                                    class="cmt-2"
                                  >
                                    mdi-home-map-marker
                                  </v-icon>
                                </b>
                                <span
                                  >{{ detail?.property_relation?.property_name
                                  }}<br
                                /></span>
                              </div>
                              <div v-else>
                                <em class="text-muted">
                                  <v-icon
                                    style="
                                      font-size: 18px;
                                      margin-top: -3px !important;
                                    "
                                    color="#000"
                                    class="cmt-2"
                                  >
                                    mdi-home-map-marker
                                  </v-icon>
                                  no Site Name</em
                                >
                              </div>
                            </template>

                            <template>
                              <div class="custom-flex-d">
                                <b>
                                  <v-icon
                                    style="
                                      font-size: 18px;
                                      margin-top: -3px !important;
                                    "
                                    color="#000"
                                    class="cmt-2"
                                  >
                                    mdi-map-marker
                                  </v-icon>
                                </b>
                                <span>
                                  <template
                                    v-if="detail?.property_relation?.unit_no"
                                    >{{
                                      detail?.property_relation?.unit_no
                                    }},</template
                                  >
                                  <template
                                    v-if="detail?.property_relation?.street_1"
                                    >{{
                                      detail?.property_relation?.street_1
                                    }},</template
                                  >
                                  {{ detail?.property_relation?.street_2 }}
                                  <br />
                                  {{ detail?.property_relation?.country }}
                                  <template
                                    v-if="
                                      detail?.property_relation?.zip_code &&
                                      detail?.property_relation?.zip_code !=
                                        '000000'
                                    "
                                  >
                                    {{ detail?.property_relation?.zip_code }}
                                  </template>
                                </span>
                              </div>
                            </template>

                            <!--  <a v-if="detail &&
                                  detail.property &&
                                  detail.property.property_address
                                  " target="_blank"
                                                            :href="`https://maps.google.com/?q=${detail.property.property_address}`">{{
                                  detail.property.property_address }}</a> -->
                          </td>
                        </tr>
                        <tr>
                          <td class="font-weight-600">Contact details</td>
                        </tr>
                        <tr
                          v-if="
                            detail?.property_contact_person_relation &&
                            detail?.property_contact_person_relation.full_name
                          "
                        >
                          <td class="py-0 font-size-18 font-weight-500">
                            {{
                              detail?.property_contact_person_relation.full_name
                            }}
                          </td>
                        </tr>
                        <tr
                          v-if="
                            detail?.property_contact_person_relation &&
                            detail?.property_contact_person_relation
                              .primary_phone
                          "
                        >
                          <td class="py-0 font-size-18 font-weight-500">
                            {{
                              detail?.property_contact_person_relation
                                .primary_phone
                            }}
                          </td>
                        </tr>
                        <tr v-else class="py-0 font-size-18 font-weight-500">
                          <em class="text-muted ml-2"> no phone number</em>
                        </tr>
                        <tr
                          v-if="
                            detail?.property_contact_person_relation &&
                            detail?.property_contact_person_relation
                              .primary_email
                          "
                        >
                          <td class="py-0 font-size-18 font-weight-500">
                            {{
                              detail?.property_contact_person_relation
                                .primary_email
                            }}
                          </td>
                        </tr>
                        <tr v-else class="py-0 font-size-18 font-weight-500">
                          <em class="text-muted ml-2"> no email address</em>
                        </tr>
                      </table>
                    </v-flex>
                    <v-flex md6 class="ml-2">
                      <table width="100%">
                        <tr>
                          <td class="font-weight-600">
                            <span
                              class="font-weight-700 custom-headline color-custom-blue font-size-16"
                            >
                              Billing Address</span
                            >
                          </td>
                        </tr>
                        <tr>
                          <td class="py-0 font-size-18 font-weight-500">
                            <template>
                              <div
                                class="custom-flex-d"
                                v-if="detail?.billing_relation?.property_name"
                              >
                                <b>
                                  <v-icon
                                    style="
                                      font-size: 18px;
                                      margin-top: -3px !important;
                                    "
                                    color="#000"
                                    class="cmt-2"
                                  >
                                    mdi-home-map-marker
                                  </v-icon>
                                </b>
                                <span
                                  >{{ detail?.billing_relation?.property_name
                                  }}<br
                                /></span>
                              </div>
                              <div v-else>
                                <em class="text-muted">
                                  <v-icon
                                    style="
                                      font-size: 18px;
                                      margin-top: -3px !important;
                                    "
                                    color="#000"
                                    class="cmt-2"
                                  >
                                    mdi-home-map-marker
                                  </v-icon>
                                  no Site Name</em
                                >
                              </div>
                            </template>

                            <template>
                              <div class="custom-flex-d">
                                <b>
                                  <v-icon
                                    style="
                                      font-size: 18px;
                                      margin-top: -3px !important;
                                    "
                                    color="#000"
                                    class="cmt-2"
                                  >
                                    mdi-map-marker
                                  </v-icon>
                                </b>
                                <span>
                                  <template
                                    v-if="detail?.billing_relation.unit_no"
                                    >{{
                                      detail?.billing_relation.unit_no
                                    }},</template
                                  >
                                  <template
                                    v-if="detail?.billing_relation.street_1"
                                    >{{
                                      detail?.billing_relation.street_1
                                    }},</template
                                  >
                                  {{ detail?.billing_relation.street_2 }}
                                  <br />
                                  {{ detail?.billing_relation.country }}
                                  <template
                                    v-if="
                                      detail?.billing_relation.zip_code &&
                                      detail?.billing_relation.zip_code !=
                                        '000000'
                                    "
                                  >
                                    {{ detail?.billing_relation.zip_code }}
                                  </template>
                                </span>
                              </div>
                            </template>

                            <!--  <a v-if="detail &&
                              detail.billing &&
                              detail.billing.property_address
                              " target="_blank"
                                                        :href="`https://maps.google.com/?q=${detail.billing.property_address}`">{{
                              detail.billing.property_address }}</a> -->
                          </td>
                        </tr>
                        <tr>
                          <td class="font-weight-600">Contact details</td>
                        </tr>
                        <tr
                          v-if="
                            detail?.billing_contact_person_relation &&
                            detail?.billing_contact_person_relation.full_name
                          "
                        >
                          <td class="py-0 font-size-18 font-weight-500">
                            {{
                              detail?.billing_contact_person_relation.full_name
                            }}
                          </td>
                        </tr>

                        <tr
                          v-if="
                            detail?.billing_contact_person_relation &&
                            detail?.billing_contact_person_relation
                              .primary_phone
                          "
                        >
                          <td class="py-0 font-size-18 font-weight-500">
                            {{
                              detail?.billing_contact_person_relation
                                .primary_phone
                            }}
                          </td>
                        </tr>
                        <tr v-else class="py-0 font-size-18 font-weight-500">
                          <em class="text-muted ml-2"> no phone number</em>
                        </tr>
                        <tr
                          v-if="
                            detail?.billing_contact_person_relation &&
                            detail?.billing_contact_person_relation
                              .primary_email
                          "
                        >
                          <td class="py-0 font-size-18 font-weight-500">
                            {{
                              detail?.billing_contact_person_relation
                                .primary_email
                            }}
                            <!-- <v-icon
                            v-if="detail.billing_person_notify"
                            v-tippy="{
                              arrow: true,
                              arrowType: 'round',
                              animation: 'fade',
                            }"
                            content="Notification was sent to given email"
                            color="green lighten-1"
                            >mdi-check</v-icon
                          > -->
                          </td>
                        </tr>
                        <tr v-else class="py-0 font-size-18 font-weight-500">
                          <em class="text-muted ml-2"> no email address</em>
                        </tr>
                      </table>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>

              <v-card flat class="custom-grey-border remove-border-radius mb-4">
                <v-card-title class="headline grey lighten-4 py-1">
                  <span
                    class="font-weight-700 custom-headline color-custom-blue font-size-16"
                    >DESCRIPTION</span
                  >
                </v-card-title>
                <v-card-text class="p-6 font-size-16">
                  <div class="w-100 custom-grey-border p-4">
                    <read-more
                      class=""
                      v-if="detail && detail.description"
                      more-str="read more"
                      :text="detail.description || '<em>No Description</em>'"
                      link="#"
                      less-str="read less"
                      :max-chars="200"
                    >
                    </read-more>
                  </div>
                </v-card-text>
              </v-card>
            </v-container>
          </v-tab-item>
          <v-tab-item value="line-item-new">
            <ViewNewLineItem
              :discount-level="'transaction'"
              :related-id="proformaId"
              :related-type="9"
            />
            <div class="mt-0 pr-2 font-weight-600">
              <table width="100%">
                <tr
                  v-if="
                    detail.proforma_type == 'deliverable' &&
                    detail?.order_relation?.proforma_initial_relation_count > 0
                  "
                >
                  <td
                    width="55%"
                    valign="middle"
                    align="right"
                    class="font-weight-700"
                  >
                    Less
                    {{ detail?.order_relation?.initial_payment_in_percentage }}
                    % Non Refundable Deposit
                  </td>
                  <td width="15%" valign="middle" align="center"></td>
                  <td
                    width="15%"
                    valign="middle"
                    align="right"
                    class="font-weight-600"
                  >
                    - {{ formatMoney(detail?.initial_payment) }}
                  </td>
                </tr>
                <tr>
                  <td width="66%" class="py-1"></td>
                  <td width="18%" align="right" class="py-1">Sub Total</td>
                  <td width="18%" align="right" class="py-1">
                    {{ formatMoney(detail.sub_total) }}
                  </td>
                </tr>
                <tr>
                  <td class="py-1"></td>
                  <td align="right" class="py-1">
                    Percentage Discount
                    <span v-if="detail?.discount_type == 1"
                      >({{ formatMoney(detail?.discount_value) }})</span
                    >
                    <span v-if="detail?.discount_type == 2"
                      >({{ formatNumber(detail?.discount_value) }}%)</span
                    >
                  </td>
                  <td align="right" class="py-1">
                    {{ formatMoney(detail?.main_discount) }}
                  </td>
                </tr>
                <tr>
                  <td class="py-1"></td>
                  <td align="right" class="py-1">
                    Lump Sum Discount
                    <span v-if="detail?.lump_discount_type == 1"
                      >({{ formatMoney(detail?.lump_discount_value) }})</span
                    >
                    <span v-if="detail?.lump_discount_type == 2"
                      >({{ formatNumber(detail?.lump_discount_value) }}%)</span
                    >
                  </td>
                  <td align="right" class="py-1">
                    {{ formatMoney(detail?.lump_sum_discount) }}
                  </td>
                </tr>

                <tr v-if="detail.tax_applied">
                  <td></td>
                  <td align="right">Tax [GST {{ detail.tax_value }}%]</td>
                  <td align="right">
                    {{ formatMoney(detail.tax_amount) }}
                  </td>
                </tr>

                <tr class="font-size-19">
                  <td class="py-1"></td>
                  <td class="py-1" align="right">Grand Total</td>
                  <td
                    class="py-1 font-weight-bold color-custom-blue"
                    align="right"
                  >
                    {{ formatMoney(detail.total) }}
                  </td>
                </tr>
              </table>
            </div>
          </v-tab-item>
          <v-tab-item value="line-item">
            <ViewLineItem is-quotation />
          </v-tab-item>
          <v-tab-item value="milestones"> </v-tab-item>
          <v-tab-item value="invoice">
            <InternalInvoice
              type="quotation"
              :type-id="proformaId"
            ></InternalInvoice>
          </v-tab-item>
          <v-tab-item value="proforma" v-if="getPermission('proforma:view')">
            <Proforma :type-id="proformaId"></Proforma>
          </v-tab-item>
          <v-tab-item value="visit">
            <VisitInternalAll
              :detail="detail"
              type="quotation"
              :quotation-id="proformaId"
            ></VisitInternalAll>
          </v-tab-item>
          <v-tab-item value="attachments">
            <AdditionalDocuments
              :type-id="detail.id"
              class="mx-4"
              type-text="Order Attachments"
              :type="5021"
              :extensive="false"
            >
            </AdditionalDocuments>
          </v-tab-item>
          <v-tab-item v-if="getPermission('history:view')" :value="'history'">
            <InternalHistoryDetail
              type="proforma"
              :type_id="detail.id"
            ></InternalHistoryDetail>
          </v-tab-item>
          <v-tab-item
            v-if="getPermission('history:view')"
            :value="'pdfHistory'"
          >
            <PDFHistoryDetail
              type="quotation"
              :type_id="detail.id"
              v-on:success="getProforma()"
            >
            </PDFHistoryDetail>
          </v-tab-item>
        </v-tabs-items>
        <!-- </v-col>
            </v-row> -->
      </v-container>
      <!--  </perfect-scrollbar> -->
      <SendMail
        :mail-dialog="mail_dialog"
        title="Send as Email"
        type="quotation"
        v-on:close="mail_dialog = false"
        :type-id="proformaId"
        v-on:success="getProforma()"
      ></SendMail>
      <Dialog :common-dialog="confirm_dialog" :dialog-width="dialogWidth">
        <template v-slot:title> Confirmation </template>
        <template v-slot:body>
          <v-form ref="statusForm" v-model.trim="formValid" lazy-validation>
            <v-container class="px-10" fluid>
              <p
                class="font-weight-600 font-size-19"
                v-if="confirm_type != 'mark_as_send'"
              >
                Are you sure, you want to
                <span class="font-weight-700">{{ get_confirm_title() }}</span
                >?
              </p>
              <p v-else class="font-weight-600 font-size-19">
                Are you sure you have
                <span class="font-weight-700"
                  >send out the order..... already to customer</span
                >?
              </p>
              <v-layout
                class="my-4"
                v-if="
                  confirm_type == 'mark_as_approved' ||
                  confirm_type == 'mark_as_rejected' ||
                  confirm_type == 'mark_as_accepted' ||
                  confirm_type == 'mark_as_unapproved'
                "
              >
                <v-flex>
                  <label class="font-weight-500 font-size-16 required"
                    >Remark</label
                  >
                  <TextAreaField
                    :rules="[
                      validateRules.required(actionData.remark, 'Remark'),
                    ]"
                    auto-grow
                    dense
                    filled
                    color="cyan"
                    v-model="actionData.remark"
                    placeholder="Remark"
                    solo
                    flat
                    row-height="25"
                    counter="200"
                  />
                </v-flex>
              </v-layout>

              <v-layout
                class="mt-4"
                v-if="
                  confirm_type == 'mark_as_accepted' ||
                  confirm_type == 'mark_as_rejected' ||
                  confirm_type == 'mark_as_approved' ||
                  confirm_type == 'mark_as_unapproved'
                "
              >
                <v-flex md12>
                  <label
                    class="font-weight-500 font-size-16"
                    :class="
                      confirm_type == 'mark_as_accepted' ? 'required' : ''
                    "
                    >Attachment</label
                  >

                  <file-upload v-model="actionData.attachments" :maxLimit="5">
                  </file-upload>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </template>
        <template v-slot:action>
          <v-btn
            :disabled="confirm_loading"
            v-on:click="confirm_dialog = false"
            class="mx-2 custom-grey-border custom-bold-button"
          >
            No! Close
          </v-btn>
          <v-btn
            v-on:click="confirm_submit()"
            :disabled="!formValid || confirm_loading"
            :loading="confirm_loading"
            class="mx-2 custom-bold-button white--text"
            color="cyan"
          >
            Yes! Continue
          </v-btn>
        </template>
      </Dialog>
      <Dialog :common-dialog="visit_count_dialog" :dialog-width="dialogWidth">
        <template v-slot:title> Visit Id Listing On Same Quotation </template>
        <template v-slot:body>
          <v-form ref="statusForm" v-model.trim="formValid" lazy-validation>
            <v-container class="px-10" fluid>
              <div class="font-weight-600 font-size-19">
                <!--    {{detail.ticket_multiple}} -->
                <table>
                  <th>Visit #</th>
                  <th>Date</th>
                  <!-- <th>Date</th> -->
                  <tr>
                    <td>
                      <template v-for="(row, index) in detail.ticket_multiple">
                        <span :key="index">
                          <v-chip
                            label
                            :color="getColor(row.visit[0].status_text)"
                            class="text-white p-2 mb-2"
                            small
                          >
                            {{ row.visit[0].barcode }}
                          </v-chip>
                          <br />
                        </span>
                      </template>
                    </td>
                    <td>
                      <template v-for="(row, index) in detail.ticket_multiple">
                        <span :key="index">
                          <v-chip
                            v-if="row && row.visit && row.visit[0]"
                            label
                            color="cyan"
                            class="text-white p-2 mb-2"
                            small
                          >
                            {{ formatDate(row.visit[0].finished_at, "") }}
                          </v-chip>
                          <br />
                        </span>
                      </template>
                    </td>
                    <!-- <td>
                          <template v-for="(row, index) in detail.ticket_multiple">
                            <span :key="index">
                              <v-chip v-if="row && row.visit && row.visit[0] && row.visit[0].teams && row.visit[0].teams.barcode" label color="cyan" class="text-white p-2" small>
                                {{row.visit[0].teams.barcode}}
                              </v-chip>
                            </span>
                          </template>
                        </td> -->
                  </tr>
                  <!--  <tr>
                    
                        <template v-for="(row, index) in detail.ticket_multiple">
                          
                          <span :key="index">
                            <v-chip v-if="row && row.visit && row.visit[0] && row.visit[0].teams && row.visit[0].teams.team_name" label color="cyan" class="text-white p-2 ml-2 mb-2" small>
                              {{ row.visit[0].teams.team_name}}
                            </v-chip>
  
                          </span>
                        </template>
                    
                   </tr> -->
                </table>
              </div>
            </v-container>
          </v-form>
        </template>
        <template v-slot:action>
          <v-btn
            :disabled="confirm_loading"
            v-on:click="visit_count_dialog = false"
            class="mx-2 custom-grey-border custom-bold-button"
          >
            No! Close
          </v-btn>
          <v-btn
            v-on:click="(confirm = true), routeToJob()"
            :disabled="!formValid || confirm_loading"
            :loading="confirm_loading"
            class="mx-2 custom-bold-button white--text"
            color="cyan"
          >
            Yes! Continue
          </v-btn>
        </template>
      </Dialog>
      <Dialog :common-dialog="download_dialog" :dialog-width="dialogWidth">
        <template v-slot:title> Download Quotation </template>
        <template v-slot:body>
          <v-container class="px-10" fluid>
            <v-col md="12">
              <v-autocomplete
                dense
                color="cyan"
                filled
                id="prepared-by"
                :items="templateList"
                :disabled="pageLoading"
                :loading="pageLoading"
                v-model.trim="download_template"
                label="Download Template"
                solo
                flat
                item-color="cyan"
                item-text="title"
                item-value="value"
                hide-details
                v-on:change="updatePreparedBy()"
              >
                <template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title
                        v-html="'No Template Found.'"
                      ></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col md="12" v-if="download_template == 'HYC_Pn_Inst'">
              <label class="font-weight-700 font-size-16"
                >Installation Clause</label
              >
              <!-- <v-textarea
                    auto-grow
                    dense
                    filled
                    flat
                    v-model="profeinstaservice.profe_insta_service"
                    label="Professional Services and Installation Services"
                    solo
                    color="cyan"
                    hide-details
                    row-height="10"
                    
                  ></v-textarea> -->
              <editor
                :disabled="formLoading"
                v-model="profeinstaservice.profe_insta_service"
              />
            </v-col>
            <v-col>
              <label class="font-weight-700 font-size-16">Download Date</label>
              <v-menu
                v-model="DatePicker"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    dense
                    filled
                    flat
                    label="Download Date"
                    hide-details
                    solo
                    :rules="[
                      validateRules.required(download_date, 'Download Date'),
                    ]"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    :value="formattedDownloadDate"
                    color="cyan"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="download_date"
                  color="cyan"
                  :min="todayDate"
                  v-on:input="DatePicker = false"
                ></v-date-picker>
              </v-menu>
            </v-col>

            <v-col>
              <label class="font-weight-700 font-size-16">Valid Till</label>
              <v-menu
                v-model="ValidDatePicker"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    dense
                    filled
                    flat
                    label="Valid Till"
                    hide-details
                    solo
                    :rules="[validateRules.required(valid_till, 'Valid Till')]"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    :value="formattedValidDate"
                    color="cyan"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="valid_till"
                  color="cyan"
                  :min="todayDate"
                  v-on:input="ValidDatePicker = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-container>
        </template>
        <template v-slot:action>
          <v-btn
            :disabled="confirm_loading"
            v-on:click="download_dialog = false"
            class="mx-2 custom-grey-border custom-bold-button"
          >
            Close
          </v-btn>
          <v-btn
            v-on:click="download_submit()"
            :disabled="confirm_loading"
            :loading="confirm_loading"
            class="mx-2 custom-bold-button white--text"
            color="cyan"
          >
            Download
          </v-btn>
        </template>
      </Dialog>

      <Dialog :commonDialog="typeConfirmDialog">
        <template v-slot:title>Confirmation</template>
        <template v-slot:body>
          <v-container fluid class="py-0">
            <v-row>
              <v-col lg="12">
                <RadioInputCustom
                  v-model="jobType"
                  row
                  color="blue darken-4"
                  :items="[
                    {
                      label: 'Adhoc Job',
                      value: 'one-off',
                    },
                    {
                      label: `Recurring Job`,
                      value: 'recurring',
                    },
                  ]"
                ></RadioInputCustom>
              </v-col>
            </v-row>
          </v-container>
        </template>
        <template v-slot:action>
          <v-btn
            class="mx-2 custom-grey-border custom-bold-button white--text"
            color="cyan"
            v-on:click="pushToVisit()"
          >
            Continue
          </v-btn>
          <v-btn
            class="mx-2 custom-grey-border custom-bold-button"
            v-on:click="typeConfirmDialog = false"
          >
            Close
          </v-btn>
        </template>
      </Dialog>
      <Dialog :commonDialog="proformaConfirmDialog">
        <template v-slot:title>Confirmation</template>
        <template v-slot:body>
          <v-container fluid class="py-0">
            <v-row>
              <v-col lg="12">
                <RadioInputCustom
                  v-model="performaType"
                  row
                  color="blue darken-4"
                  :items="[
                    {
                      label: 'Initial Proforma',
                      value: 'initial',
                    },
                    {
                      label: `Deliverable Proforma`,
                      value: 'deliverable',
                    },
                  ]"
                ></RadioInputCustom>
              </v-col>
            </v-row>
          </v-container>
        </template>
        <template v-slot:action>
          <v-btn
            class="mx-2 custom-grey-border custom-bold-button white--text"
            color="cyan"
            v-on:click="pushToPerforma(performaType)"
          >
            Continue
          </v-btn>
          <v-btn
            class="mx-2 custom-grey-border custom-bold-button"
            v-on:click="proformaConfirmDialog = false"
          >
            Close
          </v-btn>
        </template>
      </Dialog>
      <FullDialog
        v-if="notesDialog"
        :dialog="notesDialog"
        content-class="testdata"
      >
        <template v-slot:title
          >{{ detail.title }}(
          {{ detail.barcode }}
          ) Notes
          <CustomStatus
            :status="detail.status"
            endpoint="quotation/status"
          ></CustomStatus>

          <v-spacer></v-spacer>
          <v-btn
            class="text-white"
            color="red darken-4"
            depressed
            tile
            v-on:click="notesDialog = false"
          >
            Close
          </v-btn>
        </template>
        <template v-slot:body>
          <ChatNote
            v-if="notesDialog"
            :relatedId="proformaId"
            :relatedType="'quotation'"
            :documentTypes="32"
            create-url="quotation-notes"
            get-url="quotation-notes"
          ></ChatNote>
        </template>
        <!-- <template v-slot:action>
                  <v-btn class="text-white" color="red darken-4" depressed tile v-on:click="closeDialog">
                      Close
                  </v-btn>
              </template> -->
      </FullDialog>
      <!--    <div class="floating-btn-wrapper">
          <div class="position-relative">
            <div
              class="call-btn-underlay"
              style="background-color: rgb(43, 149, 105)"
            ></div>
            <v-icon
              style="font-size: 50px !important"
              color="green"
              small
              v-on:click="notesDialog = true"
              >mdi-chat
            </v-icon>
          </div>
        </div> -->
      <Invoice
        v-if="invoice_dialog"
        :reassign-schedule-dialog="invoice_dialog"
        v-on:close="invoice_dialog = false"
        :order-id="detail?.order_relation?.id"
        :updated-id="detail?.invoice_relation?.id"
        :proforma-data="detail"
        v-on:success="getProforma()"
      ></Invoice>
      <InvoiceView
        :invoice-view-dialog="invoice_view_dialog"
        v-on:close="invoice_view_dialog = false"
        :updated-id="detail?.invoice_relation?.id"
      ></InvoiceView>
    </template>
  </DetailTemplate>
</template>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import CommonMixin from "@/core/plugins/common-mixin";
import ValidationMixin from "@/core/plugins/validation-mixin";
import DetailTemplate from "@/view/pages/partials/Detail-Template.vue";
import CustomStatus from "@/view/pages/partials/CustomStatus.vue";
import ChatNote from "@/view/pages/partials/ChatNote";
import FullDialog from "@/view/components/FullDialog";
/* import QuotationLineItem from "@/view/pages/partials/Line-Item-Detail-New"; */
import InternalInvoice from "@/view/pages/partials/Internal-Invoice";
import TextAreaField from "@/view/components/app-component/TextAreaField.vue";
import ViewNewLineItem from "@/view/components/VisitLineItem.vue";

import SendMail from "@/view/pages/partials/Send-Mail";
import VisitInternalAll from "@/view/pages/partials/Detail/VisitInternalAll.vue";
import Proforma from "@/view/pages/partials/Proforma";
import {
  GET,
  /* QUERY, */ PATCH,
  PUT,
} from "@/core/services/store/request.module";
import InternalHistoryDetail from "@/view/pages/partials/Detail/Internal-History-Detail.vue";
import PDFHistoryDetail from "@/view/pages/partials/Detail/PDF-History-Detail.vue";
import JwtService from "@/core/services/jwt.service";
import Dialog from "@/view/pages/partials/Dialog";
import { ErrorEventBus, InitializeError } from "@/core/lib/message.lib";
import FileUpload from "@/view/components/app-component/FileInput";
import moment from "moment-timezone";
import AppConfiguration from "@/core/config/app.config";
import TinyMCE from "@/view/pages/partials/TinyMCE.vue";
import { PaginationEventBus } from "@/core/lib/pagination.lib";
import AdditionalDocuments from "@/view/pages/engineer/Additional-Documents";
/* import Barcode from "@/view/pages/partials/Barcode.vue"; */
import RadioInputCustom from "@/view/components/RadioInputCustom.vue";
import ViewLineItem from "@/view/components/ViewLineItem.vue";
import {
  SET_VIEW_CALCULATION,
  SET_VIEW_LINE_ITEM,
} from "@/core/services/store/line.item.v2.module";
import InvoiceView from "@/view/pages/partials/Proforma-Invoice-View";
import Invoice from "@/view/pages/partials/Proforma-Invoice";

export default {
  mixins: [CommonMixin, ValidationMixin],
  data() {
    return {
      notesDialog: false,
      jobType: "one-off",
      performaType: "initial",
      typeConfirmDialog: false,
      proformaConfirmDialog: false,
      formLoading: false,
      is_quotation_invoice_allow: false,
      tab: null,
      proformaId: 0,
      pageLoaded: false,
      statusLoading: false,
      mail_dialog: false,
      invoiceLoading: false,
      pageLoading: false,
      todayDate: null,
      DatePicker: false,
      deleteQuotationLoading: false,
      ValidDatePicker: false,
      signature: 0,
      confirm_loading: false,
      visit_count_dialog: false,
      download_template: "HYC_Pn_Inst",
      download_dialog: false,
      confirm_dialog: false,
      download_date: moment().format("YYYY-MM-DD"),
      //valid_till: moment().format("YYYY-MM-DD"),
      valid_till: moment().add(14, "days").format("YYYY-MM-DD"),
      confirm_type: null,
      /*   orderTab: "other", */
      payment_in_milestones: false,
      moreActions: [],
      detail: {},
      db_approval: {},
      dbLineItems: [],
      dbEquipments: [],
      confirm: false,
      templateList: [],
      actionData: {
        remark: null,
        attachments: [],
        status: null,
      },
      userDetails: new Object(),
      attachments: [],
      profeinstaservice: {
        profe_insta_service: null,
        quotation: null,
      },
      invoice_view_dialog: false,
      invoice_dialog: false,
    };
  },
  methods: {
    editProforma() {
      this.$router.push(
        this.getDefaultRoute("proforma.create", {
          query: {
            edit: this.detail?.id,
            type: this.detail.proforma_type,
            orderId: this.detail?.order_relation?.id,
          },
        })
      );
    },
    invoiceViewDialog() {
      this.invoice_view_dialog = true;
    },
    invoiceUpdateDialog() {
      this.invoice_dialog = true;
    },

    downloadFile() {
      const { id } = this.detail;
      const token = JwtService.getToken();
      const url = `${this.$apiURL}proforma/${id}/pdf/download?token=${token}`;

      window.open(url, "_blank");
    },

    getDueDay(day) {
      if (day == 2) {
        return 15;
      } else if (day == 3) {
        return 30;
      } else if (day == 4) {
        return 45;
      }
    },
    updateAttachment(param) {
      this.attachments = param;
    },
    lengthCount(param) {
      this.itemCount = param;
    },
    viewEnquiry(id) {
      this.$router.push(
        this.getDefaultRoute("enquiry.detail", {
          params: { id: id },
        })
      );
    },
    pageReload() {
      window.location.reload();
    },

    getValidityDate(days) {
      if (this.detail.added_at) {
        let date = moment(this.detail.added_at, "YYYY-MM-DD").format(
          "YYYY-MM-DD"
        );
        let validity = moment(date, "YYYY-MM-DD")
          .add(days, "days")
          .format("YYYY-MM-DD");
        return this.formatDate(validity);
      }
    },
    refressData() {
      this.getProforma();
    },
    generateProforma() {
      if (this.detail.proforma_relation_count > 0) {
        this.pushToPerforma("deliverable");
      } else {
        this.proformaConfirmDialog = true;
      }
    },
    pushToPerforma(type) {
      this.$router.push(
        this.getDefaultRoute("proforma.create", {
          query: {
            proformaId: this.proformaId,
            type: type,
          },
        })
      );
    },
    get_confirm_title() {
      if (this.confirm_type == "mark_as_closed") {
        return "Mark as Lost";
      } else if (this.confirm_type == "mark_as_cancelled") {
        return "Mark as Cancelled";
      } else if (this.confirm_type == "mark_as_pending") {
        return "Mark as Pending";
      } else if (this.confirm_type == "mark_as_rejected") {
        return "Mark as Rejected";
      } else if (this.confirm_type == "mark_as_accepted") {
        return "Mark as Confirmed";
      } else if (this.confirm_type == "mark_as_approved") {
        return "Mark as Approve";
      } else if (this.confirm_type == "mark_as_send") {
        return "Send Quotation";
      } else if (this.confirm_type == "submited_for_Approver") {
        return "Submit For Approval";
      } else if (this.confirm_type == "mark_as_unapproved") {
        return "Unapprove";
      }
    },
    getColor(data) {
      if (data == "Open") {
        return "blue";
      } else if (data == "In-Progress") {
        return "yellow";
      } else if (data == "Hold") {
        return "red";
      } else if (data == "Completed") {
        return "green";
      } else if (data == "Cancelled") {
        return "red";
      } else if (data == "Hold & Unassigned") {
        return "cyan";
      }
    },
    getColorType(data) {
      if (data == 1) {
        return "green darken-3";
      } else if (data == 2) {
        return "orange darken-3";
      } else if (data == 3) {
        return "red darken-3";
      }
    },
    getColorText(data) {
      if (data == 1) {
        return "New";
      } else if (data == 2) {
        return "Maintenance";
      } else if (data == 3) {
        return "General";
      }
    },
    routeToVisit(id) {
      this.$router.push({
        name: "admin.visit.detail",
        params: { id },
      });
    },

    confirm_submit() {
      const _this = this;
      const validateStatus = _this.$refs.statusForm.validate();
      const formErrors = _this.validateForm(_this.$refs.statusForm);
      if (formErrors.length) {
        for (let i = 0; i < formErrors.length; i++) {
          ErrorEventBus.$emit("update:error", InitializeError(formErrors[i]));
        }
        return false;
      }
      if (!validateStatus) {
        return false;
      }
      if (
        this.confirm_type == "mark_as_accepted" &&
        this.actionData?.attachments?.length == 0
      ) {
        ErrorEventBus.$emit("update:error", "Attachment is required");
        return false;
      }
      _this.confirm_loading = true;
      switch (this.confirm_type) {
        case "mark_as_closed":
          this.updateStatus("mark_as_closed");
          break;
        case "mark_as_send":
          this.updateStatus("mark_as_send");
          break;
        case "mark_as_cancelled":
          this.updateStatus("mark_as_cancelled");
          break;
        case "mark_as_pending":
          this.updateStatus("mark_as_pending");
          break;
        case "mark_as_rejected":
          this.updateStatus("mark_as_rejected");
          break;
        case "mark_as_accepted":
          this.updateStatus("mark_as_accepted");
          break;
        case "mark_as_approved":
          this.updateStatus("mark_as_approved");
          break;
        case "mark_as_unapproved":
          this.updateStatus("mark_as_unapproved");
          break;
        case "submited_for_Approver":
          this.updateStatus("submited_for_Approver");
          break;
      }
    },
    async download_submit() {
      if (this.download_template && this.download_dialog) {
        await this.ProfesnalInstaService();
      }
    },
    downloadPDFNew() {
      const { id } = this.detail;
      const token = JwtService.getToken();
      const url = `${this.$apiURL}order/${id}/pdf/download/${this.download_template}?token=${token}&date=${this.download_date}`;
      // console.log(url);
      window.open(url, "_blank");
      this.profeinstaservice.profe_insta_service = this.profeinstaservice
        .profe_insta_service
        ? this.profeinstaservice.profe_insta_service
        : this.detail.profe_insta_service;
      this.download_dialog = false;
    },
    getQuotationSetting() {
      const _this = this;
      _this.$store
        .dispatch(GET, { url: "setting/quotation" })
        .then(({ data }) => {
          _this.signature = data.signature.value;
          _this.payment_in_milestones = data.payment_in_milestones;
          _this.is_quotation_invoice_allow = data.is_quotation_invoice_allow;
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },

    updateMoreAction(type) {
      switch (type) {
        /*   case "edit":
            this.editQuotation();
            break; */
        case "revise":
          this.reviseQuotation();
          break;
        case "convert_visit":
          this.routeToJob();
          break;
        case "signature_link":
          this.getSignatureLink();
          break;
        case "convert_invoice":
          this.routeToInvoice();
          break;
        case "duplicate":
          this.routeToDuplicate();
          break;
        case "re_quote":
          this.requoteQuotation();
          break;
        case "mark_as_closed":
          this.confirm_dialog = true;
          this.confirm_type = "mark_as_closed";
          break;
        case "mark_as_cancelled":
          this.confirm_dialog = true;
          this.confirm_type = "mark_as_cancelled";
          break;
        case "send_as_email":
          this.mail_dialog = true;
          break;

        case "mark_as_pending":
          this.confirm_dialog = true;
          this.confirm_type = "mark_as_pending";
          break;
        case "mark_as_rejected":
          this.confirm_dialog = true;
          this.confirm_type = "mark_as_rejected";
          break;
        case "mark_as_accepted":
          this.confirm_dialog = true;
          this.confirm_type = "mark_as_accepted";
          break;
        case "mark_as_send":
          this.confirm_dialog = true;
          this.confirm_type = "mark_as_send";
          break;
        case "submited_for_Approver":
          this.confirm_dialog = true;
          this.confirm_type = "submited_for_Approver";
          break;
        case "mark_as_delete":
          this.deleteVisit();
          break;
        case "mark_as_approved":
          this.confirm_dialog = true;
          this.confirm_type = "mark_as_approved";
          break;
        case "mark_as_unapproved":
          this.confirm_dialog = true;
          this.confirm_type = "mark_as_unapproved";
          break;
        case "download_pdf":
          /* this.download_dialog = true; */
          //this.downloadPDF();
          this.downloadPDFNew();
          break;
        case "print":
          this.printPDF();
          break;
      }
    },
    getSignatureLink() {
      this.$store
        .dispatch(GET, {
          url: "quotation/" + this.proformaId + "/signature-link",
        })
        .then(({ data }) => {
          const { signature_link } = data;
          window.open(signature_link, "_blank");
        })
        .catch((error) => {
          this.logError(error);
        });
    },
    updateStatus(status) {
      if (this.statusLoading) {
        return false;
      }

      /*   this.actionData.attachments = this.attachments; */
      this.actionData.status = status;
      this.statusLoading = true;
      this.$store
        .dispatch(PATCH, {
          url: "order/" + this.proformaId + "/status",
          data: this.actionData,
        })
        .then(() => {
          this.getProforma();
          this.confirm_loading = false;
          this.confirm_dialog = false;
          this.confirm_type = null;
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.statusLoading = false;
          this.confirm_loading = false;
        });
    },
    ProfesnalInstaService() {
      const _this = this;
      // _this.pageLoading = true;
      if (_this.download_template == "HYC_Pn_Inst") {
        _this.$store
          .dispatch(PUT, {
            url: "professional-service/" + this.proformaId,
            data: {
              profe_insta_service: _this.profeinstaservice.profe_insta_service,
              quotation: _this.proformaId,
            },
          })
          .then(() => {
            this.downloadPDFNew();
            PaginationEventBus.$emit("histories-download-refresh", true);
          });
      } else {
        const { id } = this.detail;
        const token = JwtService.getToken();
        const url = `${this.$apiURL}quotation/${id}/pdf/download/${this.download_template}?token=${token}&date=${this.download_date}&valid_till=${this.valid_till}`;
        // console.log(url);
        window.open(url, "_blank");
        this.profeinstaservice.profe_insta_service =
          this.detail.profe_insta_service;
        this.download_dialog = false;

        PaginationEventBus.$emit("histories-download-refresh", true);
      }
    },

    downloadPDF() {
      const { id } = this.detail;
      const token = JwtService.getToken();
      const url = `${this.$apiURL}quotation/${id}/pdf/download?token=${token}`;
      window.open(url, "_blank");
    },
    printPDF() {
      const { id } = this.detail;
      const token = JwtService.getToken();
      const url = `${this.$apiURL}quotation/${id}/print?token=${token}`;
      window.open(url, "_blank");
    },
    routeToJob() {
      this.typeConfirmDialog = true;
    },

    routeToDuplicate() {
      this.$router.push(
        this.getDefaultRoute("quotation.create", {
          query: { duplicate: this.proformaId },
        })
      );
    },
    reviseQuotation() {
      this.$router.push(
        this.getDefaultRoute("quotation.create", {
          query: { revise: this.proformaId },
        })
      );
    },
    requoteQuotation() {
      this.$router.push(
        this.getDefaultRoute("quotation.create", {
          query: { requote: this.proformaId },
        })
      );
    },

    getProforma() {
      this.$store
        .dispatch(GET, { url: "proforma-v1/" + this.proformaId })
        .then(({ data }) => {
          this.detail = data;
          this.$store.dispatch(SET_VIEW_LINE_ITEM, this.detail?.items);
          this.$store.dispatch(SET_VIEW_CALCULATION, {
            total_selling: this.detail?.total_selling,
            total_cost_value: this.detail?.total_cost_value,
            total_margin: this.detail?.total_margin,
            discount_value: this.detail?.discount_value,
            discount_type: this.lodash.toSafeInteger(
              this.detail?.discount_type
            ),
            main_discount: this.detail?.main_discount,
            lump_discount_value: this.detail?.lump_discount_value,
            lump_discount_type: this.lodash.toSafeInteger(
              this.detail?.lump_discount_type
            ),
            lump_sum_discount: this.detail?.lump_sum_discount,
            discounted_total_selling: this.detail?.discounted_total_selling,
            grand_total: this.detail?.grand_total,
          });
          this.profeinstaservice.profe_insta_service =
            this.detail.profe_insta_service;
          this.db_approval = data.db_approval;
          this.moreActions = data.more_actions;
          this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Order", route: "orders" },
            { title: "Detail" },
            { title: data.barcode },
          ]);
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.pageLoaded = true;
        });
    },
    get_remark_title() {
      if (this.detail.status == 2) {
        return "Confirmed Remark";
      } else if (this.detail.status == 3) {
        return "Rejected Remark";
      } else {
        return null;
      }
    },
  },
  created() {
    // console.log(this.$route);

    this.proformaId = this.lodash.toSafeInteger(this.$route.params.id);
    /*  this.orderTab = this.$route.query.tab; */

    // console.log(this.orderTab, "this.orderTab");

    this.templateList = [
      /* { title: "HYC Pn Rm", value: "HYC_Pn_Rm" },
        { title: "HYC Rm", value: "HYC_Rm" },
        { title: "HYC Rm Inst", value: "HYC_Rm_Inst" }, */
      { title: "HYC Pn Inst", value: "HYC_Pn_Inst" },
      { title: "HYC Pn None", value: "HYC_Pn_None" },
    ];
  },
  mounted() {
    this.getProforma();
    this.getQuotationSetting();
    this.userDetails = JwtService.currentUser();
    //console.log(this.userDetails, "hello");
  },
  computed: {
    dialogWidth() {
      return this.lodash.toSafeInteger((document.body.clientWidth / 100) * 40);
    },
    formattedDownloadDate() {
      let Config = AppConfiguration.get();
      if (Config) {
        return moment(this.download_date).format(Config.dateFormat);
      }
      return this.download_date;
    },
    formattedValidDate() {
      let Config = AppConfiguration.get();
      if (Config) {
        return moment(this.valid_till).format(Config.dateFormat);
      }
      return this.valid_till;
    },
    orderTab: {
      set(val) {
        let query = { ...this.$route.query };
        query.tab = val;
        if (val != this.orderTab) {
          this.$router.push({ query });
        }
      },
      get() {
        return this.$route.query.tab || "other";
      },
    },
  },
  components: {
    CustomStatus,
    DetailTemplate,
    VisitInternalAll,
    SendMail,
    Dialog,
    AdditionalDocuments,
    RadioInputCustom,
    "file-upload": FileUpload,
    InternalInvoice,
    Proforma,
    TextAreaField,
    /*   Barcode, */
    ViewLineItem,
    ViewNewLineItem,
    InternalHistoryDetail,
    PDFHistoryDetail,
    editor: TinyMCE,
    FullDialog,
    ChatNote,
    InvoiceView,
    Invoice,
  },
};
</script>
